import {IdentityUser, TokensResponseDto} from "@/@types/auth.types.ts";
import {useAuthTokens} from "@/features/identity/hooks/useAuthTokens.ts";
import {useAuthUser} from "@/features/identity/hooks/useAuthUser.ts";
import {useHotelStorage} from "@/features/hotels/hooks/useHotelStorage.ts";

type Props = {
    tokens: TokensResponseDto;
    user: IdentityUser;
}

export const useSignIn = () => {
    const {setTokens} = useAuthTokens();
    const {setUser, setAuthenticated, setTenant} = useAuthUser();
    const {setSelectedHotel} = useHotelStorage();

    return (props: Props) => {
        // Start every fresh login from a clean tenant/hotel selection so stale state from a
        // previous session can't be carried over (e.g. wrong-tenant calls or a stale role).
        setTenant(undefined);
        setSelectedHotel({id: '', name: ''});
        setTokens(props.tokens);
        setUser(props.user);
        setAuthenticated(true);
    }
}